module.exports = __webpack_public_path__ + "static/media/SAS Chat Tone 3.4184fa27.mp3";